<template>
  <div
    class="event-card column rounded mr-2"
    :class="
      disabled
        ? 'tournament-grey-outline tournament-disabled'
        : 'tournament-light-blue-outline tournament-white elevate-3d elevate-3'
    "
  >
    <div class="row flex pl-4 py-4 align-center space-between">
      <div class="row align-top app-wrap">
        <!-- Event name -->
        <div v-if="event.name" class="column mr-4" style="width: 220px">
          <span class="caption tournament-grey--text">Nome do evento</span>
          <div
            :class="
              disabled
                ? 'tournament-dark-grey--text'
                : 'tournament-dark-blue--text'
            "
            class="row subheading ellipsis-2"
            style="font-weight: 500"
          >
            {{ event.name }}
          </div>
        </div>

        <!-- Event location -->
        <div
          v-if="event.event && event.event.address"
          class="column mr-4"
          style="width: 200px"
        >
          <span class="caption tournament-grey--text">Local</span>
          <div
            class="align-center subheading"
            style="font-weight: 500; line-height: 22px"
          >
            <div
              v-if="event.event.location"
              class="row bold tournament-dark-grey--text ellipsis-1"
            >
              {{ event.event.location }}
            </div>
            <div
              v-if="event.event.address.city && event.event.address.city"
              :class="
                disabled
                  ? 'tournament-dark-grey--text'
                  : 'tournament-dark-blue--text'
              "
              class="row tournament-dark-blue--text ellipsis-1"
            >
              {{ event.event.address.city }}, {{ event.event.address.state }}
            </div>
          </div>
        </div>

        <!-- Event Date -->
        <div
          v-if="event.event && event.event.startDate && event.event.endDate"
          class="column mr-4"
          style="width: 120px"
        >
          <span class="caption tournament-grey--text">Data</span>
          <div
            :class="
              disabled
                ? 'tournament-dark-grey--text'
                : 'tournament-dark-blue--text'
            "
            class="align-center subheading"
            style="font-weight: 500; line-height: 22px"
          >
            {{ event.event.startDate | FormatEventDate(event.event.endDate) }}
          </div>
        </div>

        <!-- Event Fee -->
        <div
          v-if="event.registration && event.registration.fee && !isJudge"
          class="column"
          style="width: 100px"
        >
          <span class="caption tournament-grey--text">Taxa de inscrição</span>
          <div class="align-center subheading" style="font-weight: 500">
            <span
              v-if="event.registration.fee == 0"
              :class="
                disabled
                  ? 'tournament-dark-grey--text'
                  : 'tournament-green--text'
              "
            >
              GRATUITO
            </span>
            <span
              v-else
              :class="
                disabled
                  ? 'tournament-dark-grey--text'
                  : 'tournament-dark-blue--text'
              "
            >
              {{ event.registration.fee }}
            </span>
          </div>
        </div>
      </div>

      <!-- Chevron -->
      <div
        class="row align-center justify-center border-left"
        style="width: 70px; height: 100%"
      >
        <v-icon
          color="disabled ? 'tournament-dark-grey--text' : 'tournament-light-blue--text'"
          style="font-size: 36px"
        >
          keyboard_arrow_right
        </v-icon>
      </div>
    </div>

    <!-- Event window status -->
    <div
      v-if="formatedStatus"
      class="row align-center pl-4 py-2 tournament-light-grey"
      style="min-height: 36px"
    >
      <div class="row tournament-blue--text">
        <div class="column mr-2">
          <v-icon color="tournament-blue" style="font-size: 18px">
            error_outline
          </v-icon>
        </div>
        <div class="row caption ellipsis-1 mr-2">
          {{ formatedStatus }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import EventStatus from "@/helpers/EventStatus";

export default {
  name: "EventCard",
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(["isJudge", "community"]),
    status() {
      return EventStatus(this.event);
    },

    formatedStatus() {
      const format = (dt) => moment(dt).utc().format("DD/MM/YYYY");

      const status = this.status;
      if (status.name == "unreleased") {
        return status.date
          ? "Inscrições serão liberadas em " + format(status.date)
          : "Inscrições ainda não liberadas";
      }

      if (status.name == "released") {
        return status.date
          ? "Inscrições liberadas até " + format(status.date)
          : "";
      }

      return status.date
        ? "Inscrições encerradas em " + format(status.date)
        : "Inscrições encerradas";
    },

    disabled() {
      return this.status.name != "released";
    },
  },
};
</script>

<style scoped>
.event-card {
  min-height: 120px;
  border-left: 10px solid;
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Events/Cards/Event.vue